import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { Constants } from 'src/app/app.constants';
import { UserService } from 'src/app/user/user.service';

@Injectable({
  providedIn: 'root'
})
export class ClinicianSocialworkerGuard implements CanActivate {
  constructor(private userService: UserService, private router: Router) { }
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (this.userService.getAuthToken()) {
      const role = this.userService.getRole();
      if (role == Constants.Clinician || role == Constants.CaseManager || role == Constants.SocialWorker) {
        return true;
      }
    }
    this.router.navigate(['/app']);
    return false;
  }
}
